/**
 * Created by Victor Rojo on 4/10/17.
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'iPlaceStatus'})
export class IPlaceStatusPipe implements PipeTransform {
  transform(value: number): string {
    let res = "";
    switch (value) {
      case 0:
        res = "Offline";
        break;
      case 1:
        res = "Online";
        break;
    }
    return res;
  }
}
